import { render, staticRenderFns } from "./ItemsSelection.vue?vue&type=template&id=66ad7a5f"
import script from "./ItemsSelection.vue?vue&type=script&lang=js"
export * from "./ItemsSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports